export const projects = [
    {
        "id":1,
        "title": "Las Yerberas masoterapia",
        "target": "_blank",
        "rel": "noreferrer nofollow noopener",
        "img": "las-yerberas-poster.jpeg",
        "linkDemo": "https://lasyerberasmasoterapia.netlify.app/",
        "linkGithub": "https://github.com/LorenaCoheneBaez/las-yerberas-spa",
        "tecno":"React | SASS",
    },
    {
        "id":2,
        "title": "Star Wars Planets",
        "target": "_blank",
        "rel": "noreferrer nofollow noopener",
        "img": "star-wars-poster.jpeg",
        "linkDemo": "https://starwarsplanetschallenge.netlify.app/",
        "linkGithub": "https://github.com/LorenaCoheneBaez/star-wars-planets",
        "tecno": "React | Redux | SASS",
    },
]

export const projectVideo = [
    {
        "id": 3,
        "title": "Libreria LEAF e-commerce",
        "target": "_self",
        "rel": "me",
        "img": "leaf-poster.jpeg",
        "linkDemo": "#leaf",
        "linkGithub": "https://github.com/Leaf-libreria/grupo_8_LEAF",
        "tecno": "Node.Js | MySQL | HTML | CSS",
    },
    {
        "id": 4,
        "title": "Garden Designs",
        "target": "_self",
        "rel": "me",
        "img": "garden-poster.jpeg",
        "linkDemo": "#garden",
        "linkGithub": "https://github.com/LorenaCoheneBaez/mini-proyectos-python",
        "tecno": "HTML | CSS | Javascript",
    },
]